module.exports = __webpack_public_path__ + "media/images/home/testimonials/amber-7c0ae277cc021f2e88ee756e1e5e006f.jpg";